export default __webpack_public_path__ + "static/media/multicolor_3.106808be.jpg";